/**
 * Canonical public social profile URLs and platform keys (PBI #1173).
 *
 * Single source of truth for PublicFooter follow links and Organization
 * JSON-LD sameAs. Handles match the social-launch runbook (@scheduledsmiles).
 */

/** Supported follow platforms for outbound footer links and analytics. */
export const SocialPlatform = {
  Instagram: 'instagram',
  Facebook: 'facebook',
} as const;

/** Platform key pushed on social_follow_clicked. */
export type SocialPlatform = (typeof SocialPlatform)[keyof typeof SocialPlatform];

/** Visible label for the public footer follow row. */
export const SOCIAL_FOLLOW_SECTION_LABEL = 'Follow us';

/**
 * Profile metadata rendered in PublicFooter and listed under Organization sameAs.
 */
export const SOCIAL_PROFILES = [
  {
    platform: SocialPlatform.Instagram,
    url: 'https://www.instagram.com/scheduledsmiles/',
    ariaLabel: 'Follow us on Instagram',
  },
  {
    platform: SocialPlatform.Facebook,
    url: 'https://www.facebook.com/scheduledsmiles',
    ariaLabel: 'Follow us on Facebook',
  },
] as const;

/** Organization JSON-LD sameAs list — same URLs as the footer anchors. */
export const SOCIAL_PROFILE_SAME_AS: readonly string[] = SOCIAL_PROFILES.map(
  (profile) => profile.url,
);
